export function getSpyLaunchMode(spy: any): 'sliding' | 'custom' {
    if (spy.slidingPeriods && spy.slidingPeriods.length > 0){
        return `sliding`
    }
  
    return 'custom'
}